// https://docs.microsoft.com/en-us/javascript/api/powerpoint/powerpoint.geometricshapetype?view=powerpoint-js-preview

import SummaryTemplate from './templates/SummaryTemplate'

const powerpoint = {
  add(data) {
    return SummaryTemplate.add(data)
  },

  getAvailableTemplates() {
    return {
      SummaryTemplate,
    }
  },
}

export default powerpoint
